export const locale = {
  lang: 'tr',
  data: {
    'NAV': {
      'APPLICATIONS': 'Uygulamalar',
      'CONFIG': 'Ayarlar',
      'TOOLS': {
        'TITULO': 'Araçlar',
        'CHAT': 'Sohbet',
        'TODO': 'Yapılacaklar listesi',
        'BROKER': 'Aracıya göre yapılandırma',
        'CHANGELOG': 'Değişiklik günlüğü',
        'KNOWLEDGE': 'Bilgi tabanı',
        'WEB_COM_PROF':'Web bedrijfsprofiel',
      },
      'RESULTS': {
        'TITULO': 'Sonuçlar',
        'ENLACES': {
          'TI': 'Raporlama',
          'TI_ESPANA': 'Çevrimiçi Raporlar',
          'COVID': 'COVID Anket sonuçları'
        },
        'ENLACES5': {
          'TI': 'Sonuçlar 5.0',
          'COVID': 'COVID Sonuçlar'
        },
        'ENLACES_ACTION_GO':{
          'TITULO':'ActionGo',
          // 'TITULO':'Eylem Planı - Liderler',
        },
        'ENLACES_GO_FLOW':{
          'TITULO':'Akış Sonuçlarına Git',
        }
      },
      'ACADEMY'        : {
        'TITULO': 'Test Akademisi',
        'BADGE': '69'
      },
      'CERTIFICAR'        : {
        'TITULO': 'Onayla',
        'BADGE': '69',
        'SUBPRODUCTOS': {
          '0': 'Onayla',
          '1': '2.0 Sertifikası',
          '3': '3.0 Sertifikası',
          '4': 'gümüş sertifika',
          'SPA': 'Anketi yapılandırın'
        }
      },
      'CERTIFICARN35'        : {
        'TITULO': 'NOM35 sertifikasını alın',
        'BADGE': '69'
      },
      'MEDIR'        : {
        'TITULO': 'Ölçüm',
        'BADGE': '69',
        'SUBPRODUCTOS': {
          '0': 'Ölçüm',
          '1': 'Ölçüm artırıldı',
          '2': 'Ölçüm + MST',
          '3': 'Alanlara göre ölçüm',
          '4': 'Liderlerin ölçümü',
          '5': 'Boyutlara göre ölçüm',
          '6': 'Onaylanacak ölçüm',
          '7': 'Ölçüm 3.0',
        }
      },
      'PULSE'        : {
        'TITULO': 'Pulse Check',
        'BADGE': '69',
        'SUBPRODUCTOS': {
          '0': 'Pulse Check',
          '1': 'Pulse Check 3.0',
        }
      },
      'FOCUS'        : {
        'TITULO': 'Odak Alanı',
        'BADGE': '69'
      },
      'ENCUESTAS' : {
                 'TITULO': 'Ek sertifikalar',
                 'BADGE': '69',
                 'SUBPRODUCTOS': {
                   '0': 'AMCO',
                   '1': 'İyi iş',
                   '2': 'İlk iş',
                 }
             },
             'NORMA35': {
                 'TITULO': 'Norm 035'
             },
             'NOM35BETHE': {
                 'TITULO': 'Norm 035 better'
             },
             'NOM35PLA': {
                 'TITULO': 'Norm 035 silver'
             },
             'NOM35V3': {
                 'TITULO': 'Norm 035 3.0'
             },
      'LANGUAJE'        : {
        'TITULO': 'Test dili',
        'BADGE': '69'
      },
      'LOGIN'        : {
        'TITULO': 'Test girişi',
        'BADGE': '69'
      },
      'PROFILECREATOR'        : {
        'TITULO': 'Profil oluşturucu',
        'BADGE': '69'
      },
      'PROFILELIST'        : {
        'TITULO': 'Şirket bilgileri',
        'BADGE': '69'
      },
      'NOPRODUCTOS'        : {
        'TITULO': 'Hiç ürününüz yok',
        'BADGE': '69'
      },
      'RESPTI': {
        'TITULO': 'Bilgi Teknolojileri Yöneticisi'
      },
      'REQTEC': {
        'TITULO': 'Teknik gereksinimler'
      },
      'CLOUD': {
        'TITULO': 'Dosya yöneticisi',
        'TITULO_ESPANA': 'İndirmeleri Bildir',
      },
      //Culture Audit
      'CULTURE': {
        'TITULO': 'Kültür Denetimi'
      },
      //Culture Audit2
      'CULTURE2': {
        'TITULO': 'Kültür Denetimi 5.0'
      },
      //Culture Audit training
      'CATR': {
        'TITULO': 'Kültür Denetimi Eğitimi'
      },
      //Feedback
      'FEEDBACK': {
        'TITULO': 'geri bildirim'
      },
      //Acercade
      'ABOUT': {
        'TITULO': 'Değişiklikler'
      },
      'QUESTIONS': {
        'TITULO': 'SSS'
      },
      'VIDEOS': {
        'TITULO': 'Eğitim videoları'
      },
      'CONSULTAR_E': {
        'TITULO': 'Anketlere danışın'
      },
      'CALEND_SUR': {
        'TITULO':'Anket Takvimi'
      },
      'VIDEOSADMIN': {
        'TITULO': 'Yönetici videoları'
      },
      'AUDITORIA-AUTO': {
          'TITULO':'Otomatik denetim'
        },
        'CULTUREBRI':{
          'TITULO': 'Kültür Özeti',
          'Culture Brief': 'Kültür Özeti',
        },
        'CULTUREAUDI':{
          'TITULO': 'Kültür Denetimi',
          'Culture Audit': 'Kültür Denetimi',
        },
        'CONTACTO':{
          'TITULO': 'İletişim'
        },
        'ACTIONGOADMIN':{
          'TITULO': 'Eylem GO® yöneticisi',
        },
        'ACTIONGO':{
          'TITULO': 'Eylem GO®'
        },
        'LEADERGOADMIN':{
          'TITULO': 'Önder GO® yöneticisi',
        },
        'LEADERGOUSER':{
          'TITULO': 'Önder GO®',
        },
        'medir_INNO':{
          'TITULO': 'Innmotion anketi',
        },
        'CULTURE_OZEL':{
          'TITULO': 'Özel Liste',
        },
        'Culture_Ozel_TR1':{
          'TITULO': 'Sosyal Sorumluluk & Gönüllülük',
        },
        'CONTROL_SURVE':{
          'TITULO': 'Anket kontrolü',
        },
        'CONSUL_REQUE':{
          'TITULO': 'Gereksinimleri inceleyin',
        },
        'SURVEY_GENERIC':{
        'TITULO': 'Genel anket raporu',
      },

    }
  }
};
